import { useEffect, useRef } from "react";

import { useCurrentScreen } from "@auth0/auth0-acul-react";

import { startResellerBranding } from "@/utils/reseller/applyResellerBranding";
import { getScreenComponent } from "@/utils/screen/screenLoader";

/**
 * Production Screen Manager
 * Uses Auth0 React SDK to get current screen from Universal Login context
 */
export default function ProdScreenManager() {
  const screenOptions = useCurrentScreen();
  const screenName = screenOptions?.screen?.name;
  const ScreenComponent = getScreenComponent(screenName);

  // Reseller co-branding starts here, once per page load, so it covers every
  // screen without each one passing its untrusted data. Never awaited: a
  // reseller login swaps tokens and logo when the lookup resolves; any other
  // login never fetches. Dev and the gallery do not render this manager.
  const resellerStarted = useRef(false);
  useEffect(() => {
    if (resellerStarted.current) return;
    resellerStarted.current = true;
    startResellerBranding({
      clientId: screenOptions?.client?.id,
      authorizationParams: screenOptions?.untrustedData?.authorizationParams,
    });
  }, [screenOptions]);

  if (!screenName) {
    return null;
  }

  if (ScreenComponent) {
    return <ScreenComponent key={screenName} />;
  }

  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="text-center p-8">
        <p className="text-lg text-gray-600">
          Screen &quot;{screenName}&quot; is not implemented
        </p>
      </div>
    </div>
  );
}
